module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4vkJm"))).then(() => parcelRequire('37nVf'));